import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-userdown",
  "use": "icon-userdown-usage",
  "viewBox": "0 0 1536 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1536 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-userdown\"><defs><style type=\"text/css\"></style></defs><path d=\"M748.77325476 736.41384708L515.41651266 425.27152425A29.16959278 29.16959278 0 0 1 538.75218684 378.60017582h466.71348428a29.16959278 29.16959278 0 0 1 23.3356742 46.67134843l-233.35674211 311.14232283a29.16959278 29.16959278 0 0 1-46.67134845 0z\" fill=\"#8D9299\" p-id=\"1216\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol